import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import YouTube from "react-youtube";
import { makeStyles } from "@material-ui/core/styles";
import {
    TextField,
    Typography,
    Button,
    Divider,
    Card,
    CardContent,
} from "@material-ui/core";
import { Rating } from "@material-ui/lab";
import { useParams } from "react-router-dom";
import firestore from "../firebase.config";
import firebase from "firebase/app";
import "../App.css";
import moment from "moment";

function Video() {
    const { videoId } = useParams();
    const { currentUser } = useAuth();
    const userId = currentUser.uid;
    const [video, setVideo] = useState();
    const [userGivenRating, setUserGivenRating] = useState();
    const [avgRatings, setAvgRating] = useState();
    const [comments, setComments] = useState([]);

    const updateView = async (videoId, userId) => {
        const viewsLogRef = firestore.collection("views_log");

        await viewsLogRef
            .doc()
            .set({
                viewer: userId,
                videoId: videoId,
                viewedOn: firebase.firestore.FieldValue.serverTimestamp(),
            })
            .then(() => {
                console.log("logged");
            })
            .catch((error) => {
                console.error("error: ", error);
            });

        const uniViewersRef = await viewsLogRef
            .where("videoId", "==", videoId)
            .get();

        const uniViewers = new Set(
            uniViewersRef.docs.map((doc) => doc.data().viewer)
        );

        const videoRef = firestore.collection("videos").doc(videoId);
        await videoRef
            .update({
                view: firebase.firestore.FieldValue.increment(1),
                uniqueviewers: uniViewers.size,
            })
            .then(() => {
                console.log("Updated view");
            })
            .catch((error) => {
                console.error("Error updating document: ", error);
            });

        const vidsWatchedRef = await viewsLogRef
            .where("viewer", "==", userId)
            .get();

        const vidsWatched = new Set(
            vidsWatchedRef.docs.map((doc) => doc.data().videoId)
        );

        await firestore
            .collection("users")
            .doc(userId)
            .set({ videoswatched: vidsWatched.size }, { merge: true });
    };

    const getComments = async (videoId) => {
        const commentsRef = firestore.collection("comments");
        const queryComment = await commentsRef
            .where("videoId", "==", videoId)
            .orderBy("createdAt", "desc")
            .get();

        setComments(queryComment.docs.map((doc) => doc.data()));
    };

    const addComment = async (evt) => {
        const txt = evt.target.commentField.value;

        const comm = {
            text: txt,
            username: currentUser.email.substring(
                0,
                currentUser.email.indexOf("@")
            ),
            videoId: videoId,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        };

        await firestore.collection("comments").doc().set(comm);
    };

    // get all videos
    const getVideo = async (videoId) => {
        // Query videos table on videoId for YoutubeId
        const videosRef = firestore.collection("videos");
        const queryVid = await videosRef.where("videoId", "==", videoId).get();

        queryVid.forEach((doc) => {
            //console.log(doc.id, "=>", doc.data());
            const vid = doc.data();
            setVideo(vid);
        });
    };

    const getVideoRatings = async (videoId) => {
        // 1. Query ratings table on videoId
        const ratingsRef = firestore.collection("ratings");
        const queryVid = await ratingsRef.where("videoId", "==", videoId).get();

        if (queryVid.empty) {
            return;
        }

        // 2. Aggregate all ratings
        let tot = 0;
        let num = 0;

        queryVid.forEach((doc) => {
            const data = doc.data();
            //console.log("ratings for this video", data);

            num += 1;
            tot += data.value;
        });

        // 3. update avgRatings
        const avg = +(tot / num).toFixed(2);

        setAvgRating(avg);

        const res = await firestore
            .collection("videos")
            .doc(videoId)
            .set({ avgRating: avg }, { merge: true });
        console.log(res);

        // 4. if user already given rating, use this/*
        if (userId) {
            const queryUserVideo = await ratingsRef
                .where("videoId", "==", videoId)
                .where("userId", "==", userId)
                .get();

            if (queryUserVideo.empty) {
                console.log("User has not rated");
                setUserGivenRating(0);
                return;
            } else {
                console.log("User has already rated");
                queryUserVideo.forEach((doc) => {
                    const data = doc.data();
                    //console.log("the rating is", data.value);

                    setUserGivenRating(data.value);
                });
            }
        } else console.log("loading user id");

        // update satisfaction
        const queryUser = await ratingsRef.where("userId", "==", userId).get();

        if (queryUser.empty) {
            return;
        } else {
            // 2. Aggregate all ratings
            let tot = 0;
            let num = 0;

            queryUser.forEach((doc) => {
                const data = doc.data();
                num += 1;
                tot += data.value;
            });

            // 3. update avgRatings for user
            const avg = +(tot / num).toFixed(2);

            const res = await firestore
                .collection("users")
                .doc(userId)
                .set({ satisfaction: avg }, { merge: true });
            console.log(res);
        }
    };

    const updateRating = async (e) => {
        const rating = {
            userId: userId,
            videoId: videoId,
            value: parseInt(e.target.value),
            whenRated: firebase.firestore.FieldValue.serverTimestamp(),
        };

        const doc = `${userId}_${videoId}`;

        const res = await firestore.collection("ratings").doc(doc).set(rating);
        console.log(res);

        getVideoRatings(videoId);
    };

    useEffect(() => {
        updateView(videoId, userId);
        console.log(currentUser);
        getComments(videoId);
        getVideo(videoId);
        getVideoRatings(videoId);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId, videoId]);

    const classes = useStyles();
    return (
        <div className="wrapper">
            {video && (
                <div>
                    <YouTube opts={opts} videoId={video.youtubeId} />
                    <Typography variant="h6">{video.title}</Typography>

                    <div
                        style={{
                            padding: "20px 5% 20px 5%",
                            margin: "0 auto",
                            display: "flex",
                            justifyContent: "space-around",
                        }}
                    >
                        <div
                            className="avg"
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                textAlign: "left",
                            }}
                        >
                            <Typography>Views: {video.view}</Typography>
                            <Rating
                                value={avgRatings ? avgRatings : 0}
                                readOnly
                                precision={0.5}
                                style={{ padding: 0 }}
                            />

                            <Typography>Average: {avgRatings}</Typography>
                        </div>

                        <div className="userRatings">
                            <Typography>Rate this video:</Typography>
                            <Rating
                                value={userGivenRating ? userGivenRating : 0}
                                onChange={updateRating}
                            />
                            <br />
                        </div>

                        <div style={{ display: "flex" }}>
                            <Button 
                            style={{ 
                                marginLeft: "auto",
                                width: 200,
                                marginBottom: 20,
                                margin: "0 auto",
                                background: "yellow",
                                '&:hover': {
                                    backgroundColor: '#fff',
                                    color: '#3c52b2',
                                }
                            }}>
                            Complete assessment to earn your badge!
                            </Button>
                        </div>
                    </div>

                    <div className="addComment">
                        <form
                            onSubmit={addComment}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <Typography
                                style={{
                                    paddingTop: 40,
                                    margin: "0 auto",
                                }}
                            >
                                {" "}
                                Add a comment{" "}
                            </Typography>
                            <TextField
                                style={{
                                    width: "50%",
                                    margin: "0 auto",
                                    marginTop: 20,
                                    marginBottom: 20,
                                }}
                                id="commentField"
                                autoComplete="off"
                            />
                            <Button
                                style={{
                                    width: 200,
                                    marginBottom: 20,
                                    margin: "0 auto",
                                }}
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                Submit
                            </Button>
                        </form>
                    </div>

                    <div className="comments">
                        {comments &&
                            comments.map((comment, i) => {
                                return (
                                    <div key={i}>
                                        <Card className={classes.root}>
                                            <CardContent>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        marginBottom: 20,
                                                    }}
                                                >
                                                    <Typography variant="h6">
                                                        {comment.username}
                                                    </Typography>
                                                    <Typography
                                                        variant="caption"
                                                        style={{
                                                            marginLeft: 40,
                                                            marginTop: 10,
                                                        }}
                                                    >
                                                        {moment(
                                                            Date(
                                                                comment.createdAt
                                                            )
                                                        ).format("DD MMM")}
                                                    </Typography>
                                                </div>

                                                <Typography
                                                    variant="body"
                                                    style={{
                                                        marginTop: 10,
                                                    }}
                                                >
                                                    {comment.text}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                        <Divider />
                                    </div>
                                );
                            })}
                    </div>
                </div>
            )}
        </div>
    );
}

export default Video;

const opts = {
    height: "400",
    width: "600",
    playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: 0,
    },
};

const useStyles = makeStyles({
    root: {
        minWidth: 275,
        textAlign: "left",
    },
    bullet: {
        display: "inline-block",
        margin: "0 2px",
        transform: "scale(0.8)",
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});
